(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sai-protocol", [], factory);
	else if(typeof exports === 'object')
		exports["sai-protocol"] = factory();
	else
		root["sai-protocol"] = factory();
})(global, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileRequest_1 = __webpack_require__(2);

var TaskRequest = /*#__PURE__*/function (_MobileRequest_1$defa) {
  _inherits(TaskRequest, _MobileRequest_1$defa);

  var _super = _createSuper(TaskRequest);

  function TaskRequest(service, method, domainContext, task) {
    var _this;

    _classCallCheck(this, TaskRequest);

    _this = _super.call(this, 'task', service, method, domainContext);
    _this.taskId = task;
    return _this;
  }

  _createClass(TaskRequest, [{
    key: "getTaskId",
    value: function getTaskId() {
      return this.taskId;
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var url = this.controller;
      url += '/' + this.domainContext.getDomain();
      url += '/' + this.taskId;
      url += '/' + this.service;
      return url;
    }
  }, {
    key: "setPageContext",
    value: function setPageContext(context) {
      this.page = context;
    }
  }, {
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "setKeyContext",
    value: function setKeyContext(context) {
      this.key = context;
    }
  }, {
    key: "setFilterContext",
    value: function setFilterContext(context) {
      this.filter = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          record: this.record ? this.record.toJSON() : undefined,
          page: this.page ? this.page.toJSON() : undefined,
          key: this.key ? this.key.toJSON() : undefined,
          filter: this.filter ? this.filter.toJSON() : undefined,
          message: this.message ? this.message : undefined
        }
      };
    }
  }, {
    key: "setMessageContext",
    value: function setMessageContext(response) {
      this.message = response;
    }
  }]);

  return TaskRequest;
}(MobileRequest_1["default"]);

exports.TaskRequest = TaskRequest;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileRequest_1 = __webpack_require__(2);

var ConfigurationRequest = /*#__PURE__*/function (_MobileRequest_1$defa) {
  _inherits(ConfigurationRequest, _MobileRequest_1$defa);

  var _super = _createSuper(ConfigurationRequest);

  function ConfigurationRequest(service, domain, _id) {
    var _this;

    _classCallCheck(this, ConfigurationRequest);

    _this = _super.call(this, 'configuration', service, 'GET', domain);
    _this.id = _id;
    return _this;
  }

  _createClass(ConfigurationRequest, [{
    key: "getUrl",
    value: function getUrl() {
      var url = this.controller;

      if (this.domainContext !== undefined) {
        url += '/' + this.domainContext.getId();
      }

      url += '/' + this.service;

      if (this.id !== undefined) {
        url += '/' + this.id;
      }

      return url;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }]);

  return ConfigurationRequest;
}(MobileRequest_1["default"]);

exports.ConfigurationRequest = ConfigurationRequest;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileMessage_1 = __webpack_require__(8);

var MobileRequest = /*#__PURE__*/function (_MobileMessage_1$defa) {
  _inherits(MobileRequest, _MobileMessage_1$defa);

  var _super = _createSuper(MobileRequest);

  function MobileRequest(controller, service, method, domainContext) {
    var _this;

    _classCallCheck(this, MobileRequest);

    _this = _super.call(this);
    _this.controller = controller;
    _this.service = service;
    _this.method = method;
    _this.domainContext = domainContext;
    _this.nbRetry = 0;
    return _this;
  }

  _createClass(MobileRequest, [{
    key: "getStatus",
    value: function getStatus() {
      return 100;
    }
  }, {
    key: "getController",
    value: function getController() {
      return this.controller;
    }
  }, {
    key: "getService",
    value: function getService() {
      return this.service;
    }
  }, {
    key: "getMethod",
    value: function getMethod() {
      return this.method;
    }
  }, {
    key: "getDomain",
    value: function getDomain() {
      return this.domainContext;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {};
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'MobileRequest';
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var url = this.controller;

      if (this.domainContext !== undefined) {
        url += '/' + this.domainContext.getDomain();
      }

      url += '/' + this.service;
      return url;
    }
  }, {
    key: "setSessionVars",
    value: function setSessionVars(vars) {
      this.sessionVars = vars;
    }
  }, {
    key: "getSessionVars",
    value: function getSessionVars() {
      if (this.sessionVars === undefined) {
        this.sessionVars = {};
      }

      if (this.sessionVars['CGE_EXERCICE'] === undefined && this.domainContext !== undefined && this.domainContext !== null && this.domainContext.getExercice() !== undefined) {
        this.sessionVars['CGE_EXERCICE'] = this.domainContext.getExercice().id;
      }

      return this.sessionVars;
    }
  }, {
    key: "setSessionVar",
    value: function setSessionVar(varName, varValue) {
      this.getSessionVars()[varName] = varValue;
    }
  }, {
    key: "hasSubRequests",
    value: function hasSubRequests() {
      return false;
    }
  }, {
    key: "getSubRequests",
    value: function getSubRequests() {
      return [];
    }
  }, {
    key: "getTaskId",
    value: function getTaskId() {
      return '';
    }
  }, {
    key: "isLazy",
    value: function isLazy() {
      return this.lazyAuthentication !== undefined ? this.lazyAuthentication : true;
    }
  }, {
    key: "getNbRetry",
    value: function getNbRetry() {
      return this.nbRetry;
    }
  }, {
    key: "incrementRetry",
    value: function incrementRetry() {
      this.nbRetry++;
    }
  }, {
    key: "setLastError",
    value: function setLastError(error) {
      this.lastError = error;
    }
  }, {
    key: "getLastError",
    value: function getLastError() {
      return this.lastError;
    }
  }]);

  return MobileRequest;
}(MobileMessage_1["default"]);

exports["default"] = MobileRequest;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileRequest_1 = __webpack_require__(2);

var AuthenticationRequest = /*#__PURE__*/function (_MobileRequest_1$defa) {
  _inherits(AuthenticationRequest, _MobileRequest_1$defa);

  var _super = _createSuper(AuthenticationRequest);

  function AuthenticationRequest(service, method) {
    _classCallCheck(this, AuthenticationRequest);

    return _super.call(this, 'auth', service, method, undefined);
  }

  _createClass(AuthenticationRequest, [{
    key: "getName",
    value: function getName() {
      return 'AuthenticationRequest';
    }
  }]);

  return AuthenticationRequest;
}(MobileRequest_1["default"]);

exports.AuthenticationRequest = AuthenticationRequest;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var FieldOperationRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(FieldOperationRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(FieldOperationRequest);

  function FieldOperationRequest(service, domain, task) {
    _classCallCheck(this, FieldOperationRequest);

    return _super.call(this, service, 'POST', domain, task);
  }

  _createClass(FieldOperationRequest, [{
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "setPageContext",
    value: function setPageContext(context) {
      this.page = context;
    }
  }, {
    key: "setFieldId",
    value: function setFieldId(newId) {
      this.fieldId = newId;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      var content = _get(_getPrototypeOf(FieldOperationRequest.prototype), "getSerializable", this).call(this);

      Object.assign(content.request1, {
        fieldId: this.fieldId
      });
      return content;
    }
  }]);

  return FieldOperationRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = FieldOperationRequest;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var Server_1 = __webpack_require__(15);

exports.Server = Server_1["default"];

var MockupServer_1 = __webpack_require__(20);

exports.MockupServer = MockupServer_1["default"];

var DomainContext_1 = __webpack_require__(9);

exports.DomainContext = DomainContext_1["default"];

var DomainManager_1 = __webpack_require__(21);

exports.DomainManager = DomainManager_1["default"];

var Context_1 = __webpack_require__(11);

exports.Context = Context_1["default"];

var Contexts_1 = __webpack_require__(22);

exports.ContextsCollection = Contexts_1["default"];

var Authentication_1 = __webpack_require__(23);

exports.Authentication = Authentication_1["default"];

var Portal_1 = __webpack_require__(27);

exports.Portal = Portal_1["default"];

var Configuration_1 = __webpack_require__(30);

exports.Configuration = Configuration_1["default"];

var Task_1 = __webpack_require__(42);

exports.Task = Task_1["default"];

var MobileMessage_1 = __webpack_require__(8);

exports.MobileMessage = MobileMessage_1["default"];

var MobileRequest_1 = __webpack_require__(2);

exports.MobileRequest = MobileRequest_1["default"];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);

    this.SEVERE = 1;
    this.WARNING = 2;
    this.FINE = 3;
    this.FINER = 4;
    this.FINEST = 5;
    this.DEBUG = 6;
    this.currentLevel = 2;
  }

  _createClass(Logger, [{
    key: "setLevel",
    value: function setLevel(level) {
      this.currentLevel = level;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.currentLevel;
    }
  }, {
    key: "severe",
    value: function severe(message) {
      this.displayMessage('\x1b[31m', 'SEVERE', message, this.SEVERE);
    }
  }, {
    key: "warn",
    value: function warn(message) {
      this.displayMessage('\x1b[33m', 'WARNING', message, this.WARNING);
    }
  }, {
    key: "fine",
    value: function fine(message) {
      this.displayMessage('\x1b[32m', 'FINE', message, this.FINE);
    }
  }, {
    key: "finer",
    value: function finer(message) {
      this.displayMessage('\x1b[32m', 'FINER', message, this.FINER);
    }
  }, {
    key: "finest",
    value: function finest(message) {
      this.displayMessage('\x1b[32m', 'FINEST', message, this.FINEST);
    }
  }, {
    key: "debug",
    value: function debug(message) {
      this.displayMessage('\x1b[34m', 'DEBUG', message, this.DEBUG);
    }
  }, {
    key: "displayMessage",
    value: function displayMessage(color, label, message, level) {
      if (level <= this.currentLevel) {
        console.log(color + label + '\x1b[0m %s', message);
      }
    }
  }], [{
    key: "Instance",
    get: function get() {
      return this._instance || (this._instance = new this());
    }
  }]);

  return Logger;
}();

var singleInstance = Logger.Instance;
exports["default"] = singleInstance;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetStatusRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetStatusRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetStatusRequest);

  function GetStatusRequest(initialMessage, initialResolve, initialReject, domain, task, time, count, pid) {
    var _this;

    _classCallCheck(this, GetStatusRequest);

    _this = _super.call(this, 'getStatus', 'GET', domain, task);
    _this.time = time;
    _this.count = count;
    _this.pid = pid;
    _this.internalMessage = initialMessage;
    _this.resolve = initialResolve;
    _this.reject = initialReject;
    return _this;
  }

  _createClass(GetStatusRequest, [{
    key: "getPid",
    value: function getPid() {
      return this.pid;
    }
  }, {
    key: "getCount",
    value: function getCount() {
      return this.count;
    }
  }, {
    key: "getTime",
    value: function getTime() {
      return this.time;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          pid: this.pid
        }
      };
    }
  }, {
    key: "getInitialMessage",
    value: function getInitialMessage() {
      return this.internalMessage;
    }
  }, {
    key: "getInitialMessageResolve",
    value: function getInitialMessageResolve() {
      return this.resolve;
    }
  }, {
    key: "getInitialMessageReject",
    value: function getInitialMessageReject() {
      return this.reject;
    }
  }]);

  return GetStatusRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GetStatusRequest;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileMessage = /*#__PURE__*/function () {
  function MobileMessage() {
    _classCallCheck(this, MobileMessage);
  }

  _createClass(MobileMessage, [{
    key: "getStatus",
    value: function getStatus() {
      return -1;
    }
  }, {
    key: "isPrettyPrinting",
    value: function isPrettyPrinting(response) {
      if (!response) {
        return this.forcePretty();
      } else {
        return response.isPrettyPrint();
      }
    }
  }, {
    key: "serializeNull",
    value: function serializeNull() {
      return false;
    }
  }, {
    key: "forcePretty",
    value: function forcePretty() {
      return false;
    }
  }]);

  return MobileMessage;
}();

exports["default"] = MobileMessage;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainContext = /*#__PURE__*/function () {
  function DomainContext(_domain, _id, info) {
    _classCallCheck(this, DomainContext);

    this.domain = _domain;

    if (_id) {
      this.id = _id;
    } else {
      this.id = this.generateRandomId();
    }

    this.infos = info;
  }

  _createClass(DomainContext, [{
    key: "getDomain",
    value: function getDomain() {
      return this.domain;
    }
  }, {
    key: "getInfos",
    value: function getInfos() {
      return this.infos;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getExercice",
    value: function getExercice() {
      return this.exercice;
    }
  }, {
    key: "setExercice",
    value: function setExercice(exercice) {
      this.exercice = exercice;
    }
  }, {
    key: "clone",
    value: function clone() {
      var newDomainContext = new DomainContext(this.domain, this.id);
      newDomainContext.setExercice(this.exercice);
      return newDomainContext;
    }
  }, {
    key: "generateRandomId",
    value: function generateRandomId() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }

      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
  }]);

  return DomainContext;
}();

exports["default"] = DomainContext;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthenticationRequest_1 = __webpack_require__(3);

var DomainConfigurationsRequest = /*#__PURE__*/function (_AuthenticationReques) {
  _inherits(DomainConfigurationsRequest, _AuthenticationReques);

  var _super = _createSuper(DomainConfigurationsRequest);

  function DomainConfigurationsRequest(domains) {
    var _this;

    _classCallCheck(this, DomainConfigurationsRequest);

    _this = _super.call(this, 'domains', 'GET');
    _this.domains = domains;
    return _this;
  }

  _createClass(DomainConfigurationsRequest, [{
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          domains: this.domains
        }
      };
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'DomainConfigurationsRequest';
    }
  }]);

  return DomainConfigurationsRequest;
}(AuthenticationRequest_1.AuthenticationRequest);

exports.DomainConfigurationsRequest = DomainConfigurationsRequest;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Context = /*#__PURE__*/function () {
  function Context(attributes, options) {
    _classCallCheck(this, Context);

    this.attributes = attributes || {};
    this.options = options || {};
    this.attributes.parameters = attributes.parameters || {};
    this.attributes.screen = attributes.screen || [];
    this.attributes.contextId = attributes.contextId || '';
  }

  _createClass(Context, [{
    key: "setContextId",
    value: function setContextId(newId) {
      this.attributes.contextId = newId;
    }
  }, {
    key: "getContextId",
    value: function getContextId() {
      return this.attributes.contextId;
    }
  }, {
    key: "addParameter",
    value: function addParameter(parKey, parValue) {
      this.attributes.parameters[parKey] = parValue;
    }
  }, {
    key: "getParameter",
    value: function getParameter(parKey) {
      return this.attributes.parameters[parKey];
    }
  }, {
    key: "hasParameter",
    value: function hasParameter(parKey) {
      return this.attributes.parameters.hasOwnProperty(parKey);
    }
  }, {
    key: "addPanelFields",
    value: function addPanelFields(fieldsDefinition, panelId) {
      this.attributes.screen.push({
        panelId: panelId,
        fields: fieldsDefinition
      });
    }
  }, {
    key: "getPanelFields",
    value: function getPanelFields(panelId) {
      var entries = this.attributes.screen || [];

      for (var key in entries) {
        if (entries[key].panelId === panelId) {
          return entries[key].fields;
        }
      }
    }
  }, {
    key: "addFields",
    value: function addFields(fieldsDefinition) {
      if (!fieldsDefinition) {
        return;
      }

      if (_typeof(fieldsDefinition) === 'object') {
        if (fieldsDefinition.toString().indexOf('Array') !== -1) {
          this.attributes.screen.concat(fieldsDefinition);
        } else {
          for (var defKey in fieldsDefinition) {
            var fDef = fieldsDefinition[defKey];

            if (!fDef.key) {
              fDef.key = defKey;
            }

            this.attributes.screen.push(fDef);
          }
        }
      } else {
        console.warn('Context', 'addFields', 'Wrong format for fields to add');
      }
    }
  }, {
    key: "updateField",
    value: function updateField(fieldId, nameKey, newValue) {
      if (nameKey === undefined) {
        nameKey = 'name';
      }

      var fields = this.attributes.screen;

      for (var key in fields) {
        if (fields[key][nameKey] === fieldId) {
          var rightField = fields[key];

          if (_typeof(newValue) === 'object') {
            for (var newValKey in newValue) {
              rightField[newValKey] = newValue[newValKey];
            }
          } else {
            fields[key].value = newValue;
          }
        }
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var context = {
        screen: this.attributes.screen
      };
      var params = this.attributes.parameters;

      for (var key in params) {
        context[key] = params[key];
      }

      return context;
    }
  }, {
    key: "reset",
    value: function reset(resetConfig) {
      if (resetConfig.parameters) {
        this.attributes.parameters = {};
      }

      if (resetConfig.screen) {
        this.attributes.screen = [];
      }
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(content, type) {
      var context = new Context({
        contextId: type
      });

      for (var key in content) {
        if (key === 'screen') {
          context.attributes.screen = content[key];
        } else {
          context.attributes.parameters[key] = content[key];
        }
      }

      return context;
    }
  }]);

  return Context;
}();

exports["default"] = Context;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var I18NRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(I18NRequest, _ConfigurationRequest);

  var _super = _createSuper(I18NRequest);

  function I18NRequest(domain, _id) {
    _classCallCheck(this, I18NRequest);

    return _super.call(this, 'texts', domain, _id);
  }

  return _createClass(I18NRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.I18NRequest = I18NRequest;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetRecordRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetRecordRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetRecordRequest);

  function GetRecordRequest(domain, task) {
    _classCallCheck(this, GetRecordRequest);

    return _super.call(this, 'getRecord', 'GET', domain, task);
  }

  _createClass(GetRecordRequest, [{
    key: "setKeyContext",
    value: function setKeyContext(context) {
      this.key = context;
    }
  }, {
    key: "setGridId",
    value: function setGridId(newId) {
      this.gridId = newId;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          gridId: this.gridId,
          key: this.key ? this.key.toJSON() : undefined
        }
      };
    }
  }]);

  return GetRecordRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GetRecordRequest;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __webpack_require__(16);

var Logger_1 = __webpack_require__(6);

var sessionStorage = __webpack_require__(17);

if (typeof localStorage === 'undefined' || localStorage === null) {
  var LocalStorage = __webpack_require__(18).LocalStorage;

  global['localStorage'] = new LocalStorage('./tmp-storage');
}

var querystring = __webpack_require__(19);

var GetStatus_1 = __webpack_require__(7);

var DomainContext_1 = __webpack_require__(9);

var sai_protocol_1 = __webpack_require__(5);

var DomainConfigurationsRequest_1 = __webpack_require__(10);

var Server = /*#__PURE__*/function () {
  function Server() {
    _classCallCheck(this, Server);

    this.requests = [];
    this.pendingCfgPromises = {};
  }

  _createClass(Server, [{
    key: "initialize",
    value: function initialize(options) {
      this.options = options;

      if (options.loglevel) {
        Logger_1["default"].setLevel(options.loglevel);
      }

      this.maxRetry = options.maxRetry ? options.maxRetry : 2;

      if (options.loglevel >= Logger_1["default"].FINE) {
        axios_1["default"].interceptors.response.use(function (response) {
          Logger_1["default"].finest('Response to ' + response.config.url);

          if (options.loglevel >= Logger_1["default"].DEBUG) {
            Logger_1["default"].debug(response);
          } else if (response.status !== 200) {
            Logger_1["default"].fine(response.data);
          } else if (options.loglevel >= Logger_1["default"].FINEST) {
            Logger_1["default"].finest(response.data);
          }

          return response;
        });
      }

      if (options.loglevel >= Logger_1["default"].FINER) {
        axios_1["default"].interceptors.request.use(function (request) {
          Logger_1["default"].finer('Request to' + request.url);

          if (options.loglevel >= Logger_1["default"].DEBUG) {
            Logger_1["default"].debug(request);
          } else if (options.loglevel >= Logger_1["default"].FINEST) {
            Logger_1["default"].finest(request.data);
          }

          return request;
        });
      }
    }
  }, {
    key: "getTokenedUrl",
    value: function getTokenedUrl(url) {
      if (!url) {
        return '';
      }

      var hasSlash = this.options.serverUrl.endsWith('/');

      if (!this.hasToken() || url.indexOf('public/') !== -1 || url.indexOf('configuration/') !== -1) {
        return this.options.serverUrl + (hasSlash ? '' : '/') + url;
      } else {
        return this.options.serverUrl + (hasSlash ? '' : '/') + this.token + '/' + url;
      }
    }
  }, {
    key: "hasToken",
    value: function hasToken() {
      return this.token !== undefined && this.token.length > 0;
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      this.token = token;
      sessionStorage.saiUserToken = JSON.stringify(token);
    }
  }, {
    key: "getMessageUrl",
    value: function getMessageUrl(requestMessage) {
      var hasSlash = this.options.serverUrl.endsWith('/');
      return this.options.serverUrl + (hasSlash ? '' : '/') + requestMessage.getUrl();
    }
  }, {
    key: "performRequest",
    value: function performRequest(requestMessage) {
      var _this = this;

      var allRequestsMessages = [requestMessage];

      if (requestMessage.hasSubRequests()) {
        allRequestsMessages = allRequestsMessages.concat(requestMessage.getSubRequests());
      }

      var allPromises = [];
      var me = this;

      var _loop = function _loop(key) {
        var reqMessage = allRequestsMessages[key];

        var finalUrl = _this.getMessageUrl(reqMessage);

        var isConfigCall = finalUrl.indexOf('configuration/') > 0;

        if (!isConfigCall || isConfigCall && _this.pendingCfgPromises[finalUrl] === undefined) {
          var remoteCall = new Promise(function (resolve, reject) {
            var type = reqMessage.getMethod();

            if (type === undefined) {
              console.warn('Missing type in ' + reqMessage.getName() + ' message, assuming GET');
              type = 'GET';
            }

            var device = me.options.deviceType || 'web';
            var data = {};
            var requestParams = reqMessage.getSerializable();

            for (var _key in reqMessage.getSerializable()) {
              if (typeof requestParams[_key] !== 'string') {
                data[_key] = JSON.stringify(requestParams[_key]);
              } else {
                data[_key] = requestParams[_key];
              }
            }

            data['sessionVars'] = JSON.stringify(reqMessage.getSessionVars());
            data['device'] = device;
            var alreadyPerformed = false;

            if (localStorage !== undefined) {
              var item = localStorage.getItem(reqMessage.getUrl());

              if (item !== null) {
                resolve(JSON.parse(item));
                alreadyPerformed = true;
                return;
              }
            }

            var requestHeaders = {
              post: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              },
              put: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              },
              patch: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              }
            };

            if (reqMessage.isLazy() && _this.hasToken()) {
              requestHeaders['X-Token'] = _this.token;
            }

            ;

            if (!alreadyPerformed) {
              _this.performSecuredAjax(finalUrl, type.toLocaleLowerCase(), data, requestHeaders, resolve, reject, reqMessage);
            }
          });

          if (isConfigCall) {
            _this.pendingCfgPromises[finalUrl] = remoteCall;
          } else {
            return {
              v: remoteCall
            };
          }
        }

        allPromises.push(_this.pendingCfgPromises[finalUrl]);
      };

      for (var key in allRequestsMessages) {
        var _ret = _loop(key);

        if (_typeof(_ret) === "object") return _ret.v;
      }

      return new Promise(function (accept, reject) {
        Promise.all(allPromises).then(function (results) {
          if (requestMessage['preProcess']) {
            requestMessage['preProcess'](results);
          }

          accept(results[0]);
        })["catch"](reject);
      });
    }
  }, {
    key: "checkForMessageAndResolve",
    value: function checkForMessageAndResolve(resolve, result) {
      var task = result.task;
      var foundMessage = undefined;

      if (task) {
        var ongoingMessages = result.task.messages;

        if (ongoingMessages && ongoingMessages.length > 0) {
          foundMessage = ongoingMessages[0];
        }
      }

      if (foundMessage) {
        var userMessage = foundMessage.userMessage;

        if (this.options.callbacks.displayMessageCallback) {
          this.options.callbacks.displayMessageCallback({
            title: '',
            message: userMessage,
            type: 'OK'
          });
        }
      }

      resolve(result);
    }
  }, {
    key: "performSecuredAjax",
    value: function performSecuredAjax(url, type, requestData, headers, resolve, reject, message, statusMessage) {
      var _this2 = this;

      var me = this;
      Logger_1["default"].debug('calling url ' + url);
      Logger_1["default"].debug('type is ' + type);
      Logger_1["default"].debug('data is ' + JSON.stringify(requestData));
      var baseParams = {
        url: url,
        method: type,
        params: type === 'get' ? requestData : undefined,
        data: type !== 'get' ? requestData : undefined,
        headers: headers
      };

      if (type === 'get') {
        baseParams.params = requestData;
      } else {
        baseParams.data = querystring.stringify(requestData);
      }

      axios_1["default"](baseParams).then(function (response) {
        me.setSessionTimeout();

        if (response.status === 202 || response.status === 201) {
          _this2.handleOngoing(message, resolve, reject, response.data);

          return;
        }

        var cacheHeader = response.headers['cache-control'];
        var canCache = cacheHeader !== undefined && cacheHeader.indexOf('no-cache') < 0;

        if (localStorage !== undefined && canCache) {
          try {
            localStorage.setItem(message.getUrl(), JSON.stringify(response.data));
          } catch (e) {
            console.warn('No more quota for local storage for configuration, new entries will always be fetched on the fly');
          }
        }

        me.checkForMessageAndResolve(resolve, response.data);
      })["catch"](function (error) {
        Logger_1["default"].debug(JSON.stringify(error));

        if (!error.response) {
          Logger_1["default"].severe(JSON.stringify(error));
          reject(error.errno + ': ' + error.code);
        } else {
          Logger_1["default"].severe(error.response.statusText);
          var response = error.response;

          if ([401, 403].includes(response.status)) {
            if (response.data) {
              message.setLastError(response.data.message);
            }

            _this2.options.callbacks.missingAuthCallback(message, resolve, reject, response);
          } else if ([500, 400, 502].includes(response.status)) {
            reject(response.data.message);
          } else {
            reject(response);
          }
        }
      });
    }
  }, {
    key: "handleOngoing",
    value: function handleOngoing(message, resolve, reject, result) {
      var task = result.task;

      if (!task) {
        reject(this.options.callbacks.i18NEntryCallback('ONGOING_NO_TASK'));
      }

      var ongoingMessages = result.task.messages;

      if (!ongoingMessages) {
        reject(this.options.callbacks.i18NEntryCallback('ONGOING_NO_MESSAGE'));
      }

      if (ongoingMessages.length !== 1) {
        reject(this.options.callbacks.i18NEntryCallback('ONGOING_MULTIPLE_MESSAGE'));
      }

      var ongoingMessage = ongoingMessages[0];
      var userMessage = ongoingMessage.userMessage;
      var userDetails = ongoingMessage.userDetailsMessage;
      var requests = ongoingMessage.requests;

      if (!requests) {
        reject(this.options.callbacks.i18NEntryCallback('ONGOING_NO_REQUEST'));
      }

      if (requests.length !== 1) {
        reject(this.options.callbacks.i18NEntryCallback('ONGOING_MULTIPLE_REQUEST'));
      }

      var requestToDisplay = requests[0];

      if (this.options.callbacks.ongoingMessageCallback) {
        this.options.callbacks.ongoingMessageCallback(requestToDisplay, ongoingMessage, {
          title: '',
          message: userMessage,
          type: requestToDisplay.type
        }, this.performRequest, resolve, reject);
      } else {
        console.error('Missing handler for ongoing messages');
      }
    }
  }, {
    key: "handleLongProcessingRequest",
    value: function handleLongProcessingRequest(message, resolve, reject, statusMessage, result) {
      var me = this;
      var status = statusMessage ? result.processStatus : 'INIT';

      if (status === 'SUCCESS') {
        message.getSessionVars()['FM_PROCESS_ID'] = statusMessage.getPid();
        this.performRequest(message).then(statusMessage.getInitialMessageResolve())["catch"](function (error) {
          var reject = statusMessage.getInitialMessageReject();
          reject(error);
        });
      } else if (status === 'FAILURE') {
        statusMessage.getInitialMessageReject()(result.uimessage);
      } else if (status === 'INIT' || status === 'RUNNING') {
        var previousValue = status === 'INIT' ? 0 : statusMessage.getTime();

        if (previousValue === 0) {
          previousValue = 200;
        } else if (previousValue === 200) {
          previousValue = 1000;
        } else if (previousValue === 1000) {
          previousValue = 2000;
        }

        var newRequest = new GetStatus_1["default"](message, resolve, reject, message.getDomain(), message.getTaskId(), previousValue, status === 'INIT' ? 1 : statusMessage.getCount() + 1, statusMessage ? statusMessage.getPid() : result.pid);
        setTimeout(function () {
          me.performRequest(newRequest).then(function (result) {
            me.handleLongProcessingRequest(message, resolve, reject, newRequest, result);
          })["catch"](reject);
        }, newRequest.getTime());
      } else {
        statusMessage.getInitialMessageReject()('L\'utilisateur a annulé l\'appel');
      }
    }
  }, {
    key: "addPendingRequest",
    value: function addPendingRequest(request) {
      this.requests.push(request);
    }
  }, {
    key: "recallRequests",
    value: function recallRequests() {
      var allRequest = [];

      for (var key in this.requests) {
        var currentRequest = this.requests[key];

        if (currentRequest.message.service !== 'login') {
          if (currentRequest.message.getNbRetry() < this.maxRetry) {
            currentRequest.message.incrementRetry();
            allRequest.push(this.performRequest(currentRequest.message).then(currentRequest.resolve)["catch"](currentRequest.reject));
          } else {
            allRequest.push(currentRequest.reject(currentRequest.message.getLastError()));
          }
        }
      }

      this.requests = [];
      return Promise.all(allRequest);
    }
  }, {
    key: "setSessionTimeout",
    value: function setSessionTimeout() {
      if (this.sessionTimeoutId !== undefined) {
        window.clearTimeout(this.sessionTimeoutId);
      }

      var timeout = this.options.timeout + 15000;

      if (this.options.callbacks.sessionTimeoutCallback) {
        this.sessionTimeoutId = window.setTimeout(this.options.callbacks.sessionTimeoutCallback, timeout);
      }
    }
  }, {
    key: "getContext",
    value: function getContext(domain) {
      var _this3 = this;

      return new Promise(function (accept, reject) {
        var context = sai_protocol_1.DomainManager.getContext(domain);

        if (context === undefined) {
          var fetchDomainRequest = new DomainConfigurationsRequest_1.DomainConfigurationsRequest([domain]);

          _this3.performRequest(fetchDomainRequest).then(function (response) {
            sai_protocol_1.DomainManager.setContext(domain, new DomainContext_1["default"](domain, response.domainConfigurations[domain].packageUid, response.domainConfigurations[domain]));
            accept(sai_protocol_1.DomainManager.getContext(domain));
          })["catch"](reject);
        } else {
          accept(context);
        }
      });
    }
  }], [{
    key: "Instance",
    get: function get() {
      return this._instance || (this._instance = new this());
    }
  }]);

  return Server;
}();

var singleInstance = Server.Instance;
exports["default"] = singleInstance;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = require("sessionstorage");

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = require("node-localstorage");

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = require("querystring");

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Logger_1 = __webpack_require__(6);

var MockupServer = /*#__PURE__*/function () {
  function MockupServer() {
    _classCallCheck(this, MockupServer);

    this.requests = [];
  }

  _createClass(MockupServer, [{
    key: "initialize",
    value: function initialize(options) {
      this.options = options;
      this.requestHandler = options.requestHandler;
      this.maxRetry = options.maxRetry ? options.maxRetry : 2;
    }
  }, {
    key: "getTokenedUrl",
    value: function getTokenedUrl(url) {
      if (!url) {
        return '';
      }

      this.checkInitialisation('serverUrl');
      var hasSlash = this.options.serverUrl.endsWith('/');

      if (!this.hasToken() || url.indexOf('public/') !== -1 || url.indexOf('configuration/') !== -1) {
        return this.options.serverUrl + (hasSlash ? '' : '/') + url;
      } else {
        return this.options.serverUrl + (hasSlash ? '' : '/') + this.token + '/' + url;
      }
    }
  }, {
    key: "hasToken",
    value: function hasToken() {
      return this.token !== undefined && this.token.length > 0;
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      this.token = token;
      sessionStorage.saiUserToken = JSON.stringify(token);
    }
  }, {
    key: "getMessageUrl",
    value: function getMessageUrl(requestMessage) {
      this.checkInitialisation('serverUrl');
      var hasSlash = this.options.serverUrl.endsWith('/');
      return this.options.serverUrl + (hasSlash ? '' : '/') + requestMessage.getUrl();
    }
  }, {
    key: "performRequest",
    value: function performRequest(requestMessage) {
      var url = this.getMessageUrl(requestMessage);
      Logger_1["default"].debug('Sending to ' + url + ' with payload ');
      Logger_1["default"].debug(requestMessage.getSerializable());

      if (this.requestHandler !== undefined) {
        return this.requestHandler(requestMessage, url);
      } else {
        throw new Error('Missing override of performRequest in mockup server');
      }
    }
  }, {
    key: "addPendingRequest",
    value: function addPendingRequest(request) {
      this.requests.push(request);
    }
  }, {
    key: "recallRequests",
    value: function recallRequests() {
      var allRequest = [];

      for (var key in this.requests) {
        var currentRequest = this.requests[key];

        if (currentRequest.message.service !== 'login') {
          if (currentRequest.message.getNbRetry() < this.maxRetry) {
            currentRequest.message.incrementRetry();
            allRequest.push(this.performRequest(currentRequest.message).then(currentRequest.resolve)["catch"](currentRequest.reject));
          } else {
            allRequest.push(currentRequest.reject('Maximum attempts reached'));
          }
        }
      }

      this.requests = [];
      return Promise.all(allRequest);
    }
  }, {
    key: "checkInitialisation",
    value: function checkInitialisation(prop) {
      if (this.options === undefined) {
        throw new Error('Mockup server hasn\'t been initialized');
      }

      if (this.options[prop] === undefined) {
        throw new Error('Mockup server hasn\'t been initialized with property ' + prop);
      }
    }
  }], [{
    key: "Instance",
    get: function get() {
      return this._instance || (this._instance = new this());
    }
  }]);

  return MockupServer;
}();

var singleInstance = MockupServer.Instance;
exports["default"] = singleInstance;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainManager = /*#__PURE__*/function () {
  function DomainManager() {
    _classCallCheck(this, DomainManager);

    this.domainContext = {};
  }

  _createClass(DomainManager, [{
    key: "setContext",
    value: function setContext(domainId, context) {
      this.domainContext[domainId] = context;
    }
  }, {
    key: "getContext",
    value: function getContext(domainId) {
      return this.domainContext[domainId];
    }
  }, {
    key: "getCurrentContext",
    value: function getCurrentContext(userDomain) {
      return this.domainContext[userDomain];
    }
  }, {
    key: "resetContext",
    value: function resetContext() {
      this.domainContext = {};
    }
  }], [{
    key: "Instance",
    get: function get() {
      return this._instance || (this._instance = new this());
    }
  }]);

  return DomainManager;
}();

var singleInstance = DomainManager.Instance;
exports["default"] = singleInstance;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Context_1 = __webpack_require__(11);

var ContextsCollection = /*#__PURE__*/function () {
  function ContextsCollection() {
    _classCallCheck(this, ContextsCollection);

    this.contexts = [];
  }

  _createClass(ContextsCollection, [{
    key: "addContext",
    value: function addContext(context) {
      this.removeContext(context.getContextId());
      this.contexts.push(context);
    }
  }, {
    key: "hasContext",
    value: function hasContext(contextId) {
      for (var key in this.contexts) {
        var model = this.contexts[key];

        if (model.getContextId() === contextId) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "getContext",
    value: function getContext(contextId) {
      for (var key in this.contexts) {
        var model = this.contexts[key];

        if (model.getContextId() === contextId) {
          return model;
        }
      }

      return null;
    }
  }, {
    key: "getOrCreate",
    value: function getOrCreate(contextId, resetConfig) {
      if (!this.hasContext(contextId)) {
        var newContext = new Context_1["default"]({
          contextId: contextId
        });
        this.addContext(newContext);
        return newContext;
      } else {
        var context = this.getContext(contextId);

        if (resetConfig !== undefined) {
          if (typeof resetConfig === 'boolean' && resetConfig) {
            context.reset({
              parameters: true,
              screen: true
            });
          } else if (_typeof(resetConfig) === 'object') {
            context.reset(resetConfig);
          }
        }

        return context;
      }
    }
  }, {
    key: "removeContext",
    value: function removeContext(contextId) {
      var contextKey = null;

      for (var key in this.contexts) {
        var model = this.contexts[key];

        if (model.getContextId() === contextId) {
          contextKey = key;
          break;
        }
      }

      if (contextKey != null) {
        this.contexts.splice(contextKey, 1);
      }
    }
  }, {
    key: "getPartial",
    value: function getPartial(contextsList) {
      var partial = new ContextsCollection();

      for (var key in contextsList) {
        partial.addContext(this.getContext(contextsList[key]));
      }

      return partial;
    }
  }, {
    key: "toJSONString",
    value: function toJSONString() {
      var _final = {};

      for (var key in this.contexts) {
        var model = this.contexts[key];
        _final[model.getContextId() || 'undefinedContext'] = model.toJSON();
      }

      return JSON.stringify(_final);
    }
  }]);

  return ContextsCollection;
}();

exports["default"] = ContextsCollection;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthenticationRequest_1 = __webpack_require__(3);

var LoginRequest_1 = __webpack_require__(24);

var PasswordUpdateRequest_1 = __webpack_require__(25);

var UserInfosRequest_1 = __webpack_require__(26);

var DomainConfigurationsRequest_1 = __webpack_require__(10);

exports["default"] = {
  AuthenticationRequest: AuthenticationRequest_1.AuthenticationRequest,
  LoginRequest: LoginRequest_1.LoginRequest,
  PasswordUpdateRequest: PasswordUpdateRequest_1.PasswordUpdateRequest,
  UserInfosRequest: UserInfosRequest_1.UserInfosRequest,
  DomainConfigurationsRequest: DomainConfigurationsRequest_1.DomainConfigurationsRequest
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthenticationRequest_1 = __webpack_require__(3);

var LoginRequest = /*#__PURE__*/function (_AuthenticationReques) {
  _inherits(LoginRequest, _AuthenticationReques);

  var _super = _createSuper(LoginRequest);

  function LoginRequest(user, pass, token) {
    var _this;

    _classCallCheck(this, LoginRequest);

    _this = _super.call(this, 'login', 'POST');

    _this.setUserName(user);

    _this.setPassword(pass);

    _this.token = token;
    _this.lazyAuthentication = false;
    return _this;
  }

  _createClass(LoginRequest, [{
    key: "setUserName",
    value: function setUserName(username) {
      this.username = username;
    }
  }, {
    key: "setPassword",
    value: function setPassword(pass) {
      this.password = pass;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        'auth-login': this.username,
        'auth-pass': this.password
      };
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'LoginRequest';
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      if (!this.token) {
        return _get(_getPrototypeOf(LoginRequest.prototype), "getUrl", this).call(this);
      } else {
        var url = this.token;
        url += '/' + this.controller;
        url += '/' + this.service;
        return url;
      }
    }
  }]);

  return LoginRequest;
}(AuthenticationRequest_1.AuthenticationRequest);

exports.LoginRequest = LoginRequest;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthenticationRequest_1 = __webpack_require__(3);

var PasswordUpdateRequest = /*#__PURE__*/function (_AuthenticationReques) {
  _inherits(PasswordUpdateRequest, _AuthenticationReques);

  var _super = _createSuper(PasswordUpdateRequest);

  function PasswordUpdateRequest(userId, oldPassword, newPassword) {
    var _this;

    _classCallCheck(this, PasswordUpdateRequest);

    _this = _super.call(this, 'updatepassword', 'GET');
    _this.userId = userId;
    _this.oldPassword = oldPassword;
    _this.newPassword = newPassword;
    return _this;
  }

  _createClass(PasswordUpdateRequest, [{
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          userId: this.userId,
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        }
      };
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'PasswordUpdateRequest';
    }
  }]);

  return PasswordUpdateRequest;
}(AuthenticationRequest_1.AuthenticationRequest);

exports.PasswordUpdateRequest = PasswordUpdateRequest;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthenticationRequest_1 = __webpack_require__(3);

var UserInfosRequest = /*#__PURE__*/function (_AuthenticationReques) {
  _inherits(UserInfosRequest, _AuthenticationReques);

  var _super = _createSuper(UserInfosRequest);

  function UserInfosRequest(domain) {
    var _this;

    _classCallCheck(this, UserInfosRequest);

    _this = _super.call(this, 'info', 'GET');
    _this.domainName = domain;
    return _this;
  }

  _createClass(UserInfosRequest, [{
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          domain: this.domainName
        }
      };
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'UserInfosRequest';
    }
  }]);

  return UserInfosRequest;
}(AuthenticationRequest_1.AuthenticationRequest);

exports.UserInfosRequest = UserInfosRequest;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var PortalLoginRequest_1 = __webpack_require__(28);

var PortalExternalIdLoginRequest_1 = __webpack_require__(29);

exports["default"] = {
  PortalLoginRequest: PortalLoginRequest_1.PortalLoginRequest,
  PortalExternalIdLoginRequest: PortalExternalIdLoginRequest_1.PortalExternalIdLoginRequest
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileRequest_1 = __webpack_require__(2);

var PortalLoginRequest = /*#__PURE__*/function (_MobileRequest_1$defa) {
  _inherits(PortalLoginRequest, _MobileRequest_1$defa);

  var _super = _createSuper(PortalLoginRequest);

  function PortalLoginRequest(domain, user, pass) {
    var _this;

    _classCallCheck(this, PortalLoginRequest);

    _this = _super.call(this, 'portal', 'login', 'POST', domain);

    _this.setUserName(user);

    _this.setPassword(pass);

    return _this;
  }

  _createClass(PortalLoginRequest, [{
    key: "setUserName",
    value: function setUserName(username) {
      this.username = username;
    }
  }, {
    key: "setPassword",
    value: function setPassword(pass) {
      this.password = pass;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          'user': this.username,
          'hashedPassword': this.password
        }
      };
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var url = this.controller;
      url += '/' + this.domainContext.getDomain();
      url += '/' + this.service;
      return url;
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'PortalLoginRequest';
    }
  }]);

  return PortalLoginRequest;
}(MobileRequest_1["default"]);

exports.PortalLoginRequest = PortalLoginRequest;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileRequest_1 = __webpack_require__(2);

var PortalExternalIdLoginRequest = /*#__PURE__*/function (_MobileRequest_1$defa) {
  _inherits(PortalExternalIdLoginRequest, _MobileRequest_1$defa);

  var _super = _createSuper(PortalExternalIdLoginRequest);

  function PortalExternalIdLoginRequest(domain, externalId) {
    var _this;

    _classCallCheck(this, PortalExternalIdLoginRequest);

    _this = _super.call(this, 'portal', 'externalIdLogin', 'POST', domain);

    _this.setExternalId(externalId);

    return _this;
  }

  _createClass(PortalExternalIdLoginRequest, [{
    key: "setExternalId",
    value: function setExternalId(externalId) {
      this.externalId = externalId;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          'externalId': this.externalId
        }
      };
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var url = this.controller;
      url += '/' + this.domainContext.getDomain();
      url += '/' + this.service;
      return url;
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'PortalExternalIdLoginRequest';
    }
  }]);

  return PortalExternalIdLoginRequest;
}(MobileRequest_1["default"]);

exports.PortalExternalIdLoginRequest = PortalExternalIdLoginRequest;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var ChainRequest_1 = __webpack_require__(31);

var ColorThemeRequest_1 = __webpack_require__(32);

var ComboRequest_1 = __webpack_require__(33);

var ConfigurationRequest_1 = __webpack_require__(1);

var DashboardRequest_1 = __webpack_require__(34);

var FilterRequest_1 = __webpack_require__(35);

var GridViewRequest_1 = __webpack_require__(36);

var I18NRequest_1 = __webpack_require__(12);

var PopupMenuRequest_1 = __webpack_require__(37);

var TableRequest_1 = __webpack_require__(38);

var TaskRequest_1 = __webpack_require__(39);

var WallpaperRequest_1 = __webpack_require__(40);

var HelpRequest_1 = __webpack_require__(41);

exports["default"] = {
  ChainRequest: ChainRequest_1.ChainRequest,
  ColorThemeRequest: ColorThemeRequest_1.ColorThemeRequest,
  ComboRequest: ComboRequest_1.ComboRequest,
  ConfigurationRequest: ConfigurationRequest_1.ConfigurationRequest,
  DashboardRequest: DashboardRequest_1.DashboardRequest,
  FilterRequest: FilterRequest_1.FilterRequest,
  GridViewRequest: GridViewRequest_1.GridViewRequest,
  I18NRequest: I18NRequest_1.I18NRequest,
  PopupMenuRequest: PopupMenuRequest_1.PopupMenuRequest,
  TableRequest: TableRequest_1.TableRequest,
  TaskRequest: TaskRequest_1.TaskRequest,
  WallpaperRequest: WallpaperRequest_1.WallpaperRequest,
  HelpRequest: HelpRequest_1.HelpRequest
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var ChainRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(ChainRequest, _ConfigurationRequest);

  var _super = _createSuper(ChainRequest);

  function ChainRequest(domain, _id) {
    _classCallCheck(this, ChainRequest);

    return _super.call(this, 'chain', domain, _id);
  }

  return _createClass(ChainRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.ChainRequest = ChainRequest;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var ColorThemeRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(ColorThemeRequest, _ConfigurationRequest);

  var _super = _createSuper(ColorThemeRequest);

  function ColorThemeRequest(domain, _id) {
    _classCallCheck(this, ColorThemeRequest);

    return _super.call(this, 'theme', domain, _id);
  }

  return _createClass(ColorThemeRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.ColorThemeRequest = ColorThemeRequest;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var ComboRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(ComboRequest, _ConfigurationRequest);

  var _super = _createSuper(ComboRequest);

  function ComboRequest(domain, _id) {
    _classCallCheck(this, ComboRequest);

    return _super.call(this, 'combo', domain, _id);
  }

  return _createClass(ComboRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.ComboRequest = ComboRequest;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var I18NRequest_1 = __webpack_require__(12);

var DashboardRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(DashboardRequest, _ConfigurationRequest);

  var _super = _createSuper(DashboardRequest);

  function DashboardRequest(domain, _id) {
    var _this;

    _classCallCheck(this, DashboardRequest);

    _this = _super.call(this, 'dashboard', domain, _id.substring(0, _id.lastIndexOf('/')));
    _this.lang = _id.substring(_id.lastIndexOf('/') + 1, _id.length);
    return _this;
  }

  _createClass(DashboardRequest, [{
    key: "preProcess",
    value: function preProcess(results) {
      var dash = results[0];
      var i18nValues = results[1].texts || {};
      var dashId = dash.id;

      if (true) {
        dash.label = i18nValues[dashId + '.label'];
      }

      for (var gId in dash.groups) {
        var curGrp = dash.groups[gId];
        var groupId = dashId + '.' + curGrp.id;

        if (i18nValues[groupId + '.label']) {
          curGrp.config.label = i18nValues[groupId + '.label'];
        }

        for (var tId in curGrp.tiles) {
          var curTile = curGrp.tiles[tId];
          var tileId = groupId + '.' + curTile.id;

          if (i18nValues[tileId + '.label']) {
            curTile.config.label = i18nValues[tileId + '.label'];
          }

          if (i18nValues[tileId + '.shortlabel']) {
            curTile.config.label = i18nValues[tileId + '.shortlabel'];
          }

          if (i18nValues[tileId + '.veryshortlabel']) {
            curTile.config.label = i18nValues[tileId + '.veryshortlabel'];
          }

          if (i18nValues[tileId + '.icon']) {
            curTile.visual.icon = i18nValues[tileId + '.icon'];
          }
        }
      }
    }
  }, {
    key: "hasSubRequests",
    value: function hasSubRequests() {
      return true;
    }
  }, {
    key: "getSubRequests",
    value: function getSubRequests() {
      var reqParts = this.getId().split('/');
      var dashId = reqParts[reqParts.length - 1];
      return [new I18NRequest_1.I18NRequest(this.getDomain(), 'dashboard/' + this.lang + '/' + dashId.substring(0, 3))];
    }
  }]);

  return DashboardRequest;
}(ConfigurationRequest_1.ConfigurationRequest);

exports.DashboardRequest = DashboardRequest;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var FilterRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(FilterRequest, _ConfigurationRequest);

  var _super = _createSuper(FilterRequest);

  function FilterRequest(domain, _id) {
    _classCallCheck(this, FilterRequest);

    return _super.call(this, 'filter', domain, _id);
  }

  return _createClass(FilterRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.FilterRequest = FilterRequest;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var GridViewRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(GridViewRequest, _ConfigurationRequest);

  var _super = _createSuper(GridViewRequest);

  function GridViewRequest(domain, _id) {
    _classCallCheck(this, GridViewRequest);

    return _super.call(this, 'grid', domain, _id);
  }

  return _createClass(GridViewRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.GridViewRequest = GridViewRequest;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var PopupMenuRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(PopupMenuRequest, _ConfigurationRequest);

  var _super = _createSuper(PopupMenuRequest);

  function PopupMenuRequest(domain, _id) {
    _classCallCheck(this, PopupMenuRequest);

    return _super.call(this, 'popupmenus', domain, _id);
  }

  return _createClass(PopupMenuRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.PopupMenuRequest = PopupMenuRequest;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var TableRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(TableRequest, _ConfigurationRequest);

  var _super = _createSuper(TableRequest);

  function TableRequest(domain, _id) {
    _classCallCheck(this, TableRequest);

    return _super.call(this, 'table', domain, _id);
  }

  return _createClass(TableRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.TableRequest = TableRequest;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var TaskRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(TaskRequest, _ConfigurationRequest);

  var _super = _createSuper(TaskRequest);

  function TaskRequest(domain, _id) {
    _classCallCheck(this, TaskRequest);

    return _super.call(this, 'task', domain, _id);
  }

  _createClass(TaskRequest, [{
    key: "preProcess",
    value: function preProcess(results) {
      results[0] = results[0].task;
    }
  }]);

  return TaskRequest;
}(ConfigurationRequest_1.ConfigurationRequest);

exports.TaskRequest = TaskRequest;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var WallpaperRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(WallpaperRequest, _ConfigurationRequest);

  var _super = _createSuper(WallpaperRequest);

  function WallpaperRequest(domain, _themeId, _id) {
    _classCallCheck(this, WallpaperRequest);

    return _super.call(this, 'theme/' + _themeId + '/wallpaper', domain, _id);
  }

  return _createClass(WallpaperRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.WallpaperRequest = WallpaperRequest;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var HelpRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(HelpRequest, _ConfigurationRequest);

  var _super = _createSuper(HelpRequest);

  function HelpRequest(domain, _id) {
    _classCallCheck(this, HelpRequest);

    return _super.call(this, 'help', domain, _id);
  }

  return _createClass(HelpRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.HelpRequest = HelpRequest;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var FieldChange_1 = __webpack_require__(43);

var FieldClick_1 = __webpack_require__(44);

var FieldOperationRequest_1 = __webpack_require__(4);

var GetDossier_1 = __webpack_require__(45);

var GetGridData_1 = __webpack_require__(46);

var GetNotification_1 = __webpack_require__(47);

var GetPage_1 = __webpack_require__(48);

var GetRecord_1 = __webpack_require__(13);

var GetStatus_1 = __webpack_require__(7);

var GetTask_1 = __webpack_require__(49);

var GridAction_1 = __webpack_require__(50);

var PostNotification_1 = __webpack_require__(51);

var PrepareNewEntry_1 = __webpack_require__(52);

var PrepareNewPage_1 = __webpack_require__(53);

var PrintFile_1 = __webpack_require__(54);

var SubmitPage_1 = __webpack_require__(55);

var SubmitRecord_1 = __webpack_require__(56);

var TaskListing_1 = __webpack_require__(57);

var TaskRequest_1 = __webpack_require__(0);

exports["default"] = {
  FieldChangeRequest: FieldChange_1["default"],
  FieldClickRequest: FieldClick_1["default"],
  FieldOperationRequest: FieldOperationRequest_1["default"],
  GetDossierRequest: GetDossier_1["default"],
  GetGridDataRequest: GetGridData_1["default"],
  GetNotificationRequest: GetNotification_1["default"],
  GetPageRequest: GetPage_1["default"],
  GetRecordRequest: GetRecord_1["default"],
  GetStatusRequest: GetStatus_1["default"],
  GetTaskRequest: GetTask_1["default"],
  GridActionRequest: GridAction_1["default"],
  PostNotificationRequest: PostNotification_1["default"],
  PrepareNewEntryRequest: PrepareNewEntry_1["default"],
  PrepareNewPageRequest: PrepareNewPage_1["default"],
  PrintFileRequest: PrintFile_1["default"],
  SubmitPageRequest: SubmitPage_1["default"],
  SubmitRecordRequest: SubmitRecord_1["default"],
  TaskListingRequest: TaskListing_1["default"],
  TaskRequest: TaskRequest_1.TaskRequest
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FieldOperationRequest_1 = __webpack_require__(4);

var FieldChangeRequest = /*#__PURE__*/function (_FieldOperationReques) {
  _inherits(FieldChangeRequest, _FieldOperationReques);

  var _super = _createSuper(FieldChangeRequest);

  function FieldChangeRequest(domain, task) {
    _classCallCheck(this, FieldChangeRequest);

    return _super.call(this, 'fieldChange', domain, task);
  }

  _createClass(FieldChangeRequest, [{
    key: "setLastValue",
    value: function setLastValue(value) {
      this.lastValue = value || '';
    }
  }, {
    key: "setLastNonEmptyValue",
    value: function setLastNonEmptyValue(value) {
      this.lastNonEmptyValue = value || '';
    }
  }, {
    key: "setInitialValue",
    value: function setInitialValue(value) {
      this.initialValue = value || '';
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      var request = _get(_getPrototypeOf(FieldChangeRequest.prototype), "getSerializable", this).call(this);

      request.request1.lastValue = this.lastValue;
      request.request1.lastNonEmptyValue = this.lastNonEmptyValue;
      request.request1.initialValue = this.initialValue;
      return request;
    }
  }]);

  return FieldChangeRequest;
}(FieldOperationRequest_1["default"]);

exports["default"] = FieldChangeRequest;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FieldOperationRequest_1 = __webpack_require__(4);

var FieldClickRequest = /*#__PURE__*/function (_FieldOperationReques) {
  _inherits(FieldClickRequest, _FieldOperationReques);

  var _super = _createSuper(FieldClickRequest);

  function FieldClickRequest(domain, task) {
    _classCallCheck(this, FieldClickRequest);

    return _super.call(this, 'fieldClick', domain, task);
  }

  return _createClass(FieldClickRequest);
}(FieldOperationRequest_1["default"]);

exports["default"] = FieldClickRequest;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GetRecord_1 = __webpack_require__(13);

var GetDossierRequest = /*#__PURE__*/function (_GetRecord_1$default) {
  _inherits(GetDossierRequest, _GetRecord_1$default);

  var _super = _createSuper(GetDossierRequest);

  function GetDossierRequest(domain, task) {
    var _this;

    _classCallCheck(this, GetDossierRequest);

    _this = _super.call(this, domain, task);
    _this.service = 'getDossier';
    return _this;
  }

  return _createClass(GetDossierRequest);
}(GetRecord_1["default"]);

exports["default"] = GetDossierRequest;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetGridDataRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetGridDataRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetGridDataRequest);

  function GetGridDataRequest(domain, task, gridId) {
    var _this;

    _classCallCheck(this, GetGridDataRequest);

    _this = _super.call(this, 'getGridData', 'POST', domain, task);
    _this.gridId = gridId;
    _this.range = {
      start: 0,
      end: 20
    };
    _this.filterId = 'DEFAULT_FILTER';
    _this.gridFilter = {
      customText: undefined,
      context: undefined
    };
    return _this;
  }

  _createClass(GetGridDataRequest, [{
    key: "getGridId",
    value: function getGridId(newId) {
      this.gridId = newId;
    }
  }, {
    key: "setFilterId",
    value: function setFilterId(newId) {
      this.filterId = newId;
    }
  }, {
    key: "setFormatterId",
    value: function setFormatterId(newId) {
      this.formatterId = newId;
    }
  }, {
    key: "setRange",
    value: function setRange(start, end) {
      this.range = {
        start: start,
        end: end
      };
    }
  }, {
    key: "setCustomFilterText",
    value: function setCustomFilterText(customText) {
      this.gridFilter.customText = customText;
    }
  }, {
    key: "setFilterContext",
    value: function setFilterContext(context) {
      this.gridFilter.context = context;
    }
  }, {
    key: "setSessionVars",
    value: function setSessionVars(vars) {
      this.sessionVars = vars;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          gridId: this.gridId,
          filterId: this.filterId,
          formatterId: this.formatterId,
          start: this.range.start,
          end: this.range.end,
          customText: this.gridFilter.customText,
          filter: this.gridFilter.context ? this.gridFilter.context.toJSON() : undefined,
          record: this.record ? this.record.toJSON() : undefined,
          page: this.page ? this.page.toJSON() : undefined
        }
      };
    }
  }]);

  return GetGridDataRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GetGridDataRequest;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetNotificationRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetNotificationRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetNotificationRequest);

  function GetNotificationRequest(domain, task, id) {
    var _this;

    _classCallCheck(this, GetNotificationRequest);

    _this = _super.call(this, 'notification/' + id, 'POST', domain, task);
    _this.remoteArguments = {};
    return _this;
  }

  _createClass(GetNotificationRequest, [{
    key: "setNotificationArgument",
    value: function setNotificationArgument(paramId, paramValue) {
      this.remoteArguments[paramId] = paramValue;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      var content = _get(_getPrototypeOf(GetNotificationRequest.prototype), "getSerializable", this).call(this);

      content.request1.parameters = this.remoteArguments;
      return content;
    }
  }]);

  return GetNotificationRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GetNotificationRequest;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetPageRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetPageRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetPageRequest);

  function GetPageRequest(domain, task) {
    _classCallCheck(this, GetPageRequest);

    return _super.call(this, 'getPage', 'GET', domain, task);
  }

  _createClass(GetPageRequest, [{
    key: "setPageContext",
    value: function setPageContext(context) {
      this.page = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          page: this.page ? this.page.toJSON() : undefined
        }
      };
    }
  }]);

  return GetPageRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GetPageRequest;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetTaskRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetTaskRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetTaskRequest);

  function GetTaskRequest(domain, task) {
    _classCallCheck(this, GetTaskRequest);

    return _super.call(this, 'getTask', 'GET', domain, task);
  }

  return _createClass(GetTaskRequest);
}(TaskRequest_1.TaskRequest);

exports["default"] = GetTaskRequest;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GridActionRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GridActionRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GridActionRequest);

  function GridActionRequest(domain, task, gridId, popupId, itemId, actionId, gridIndex) {
    var _this;

    _classCallCheck(this, GridActionRequest);

    _this = _super.call(this, 'gridAction', 'POST', domain, task);

    _this.setGridId(gridId);

    _this.setPopupId(popupId);

    _this.setItemId(itemId);

    _this.setActionId(actionId);

    _this.setGridIndex(gridIndex);

    return _this;
  }

  _createClass(GridActionRequest, [{
    key: "setGridContext",
    value: function setGridContext(context) {
      this.grid = context;
    }
  }, {
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "setGridId",
    value: function setGridId(id) {
      this.gridId = id;
    }
  }, {
    key: "setPopupId",
    value: function setPopupId(id) {
      this.popupId = id;
    }
  }, {
    key: "setItemId",
    value: function setItemId(id) {
      this.itemId = id;
    }
  }, {
    key: "setActionId",
    value: function setActionId(id) {
      this.actionId = id;
    }
  }, {
    key: "setGridIndex",
    value: function setGridIndex(index) {
      this.gridIndex = index;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          gridId: this.gridId,
          grid: this.grid ? this.grid.toJSON() : undefined,
          record: this.record ? this.record.toJSON() : undefined,
          popupId: this.popupId,
          itemId: this.itemId,
          actionId: this.actionId,
          gridIndex: this.gridIndex
        }
      };
    }
  }]);

  return GridActionRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GridActionRequest;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var PostNotificationRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(PostNotificationRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(PostNotificationRequest);

  function PostNotificationRequest(domain, task, id) {
    var _this;

    _classCallCheck(this, PostNotificationRequest);

    _this = _super.call(this, 'notification/' + id, 'POST', domain, task);
    _this.remoteArguments = {};
    return _this;
  }

  _createClass(PostNotificationRequest, [{
    key: "setNotificationArgument",
    value: function setNotificationArgument(paramId, paramValue) {
      this.remoteArguments[paramId] = paramValue;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      var content = _get(_getPrototypeOf(PostNotificationRequest.prototype), "getSerializable", this).call(this);

      content.request1.parameters = this.remoteArguments;
      return content;
    }
  }]);

  return PostNotificationRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = PostNotificationRequest;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var PrepareNewEntryRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(PrepareNewEntryRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(PrepareNewEntryRequest);

  function PrepareNewEntryRequest(domain, task) {
    _classCallCheck(this, PrepareNewEntryRequest);

    return _super.call(this, 'prepareNewEntry', 'POST', domain, task);
  }

  _createClass(PrepareNewEntryRequest, [{
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          record: this.record ? this.record.toJSON() : undefined
        }
      };
    }
  }]);

  return PrepareNewEntryRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = PrepareNewEntryRequest;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var PrepareNewPageRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(PrepareNewPageRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(PrepareNewPageRequest);

  function PrepareNewPageRequest(domain, task) {
    _classCallCheck(this, PrepareNewPageRequest);

    return _super.call(this, 'prepareNewPage', 'POST', domain, task);
  }

  _createClass(PrepareNewPageRequest, [{
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "setPageContext",
    value: function setPageContext(context) {
      this.page = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          record: this.record ? this.record.toJSON() : undefined,
          page: this.page ? this.page.toJSON() : undefined
        }
      };
    }
  }]);

  return PrepareNewPageRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = PrepareNewPageRequest;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var PrintFileRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(PrintFileRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(PrintFileRequest);

  function PrintFileRequest(domain, task) {
    _classCallCheck(this, PrintFileRequest);

    return _super.call(this, 'printFile', 'POST', domain, task);
  }

  return _createClass(PrintFileRequest);
}(TaskRequest_1.TaskRequest);

exports["default"] = PrintFileRequest;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var SubmitPageRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(SubmitPageRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(SubmitPageRequest);

  function SubmitPageRequest(domain, task) {
    _classCallCheck(this, SubmitPageRequest);

    return _super.call(this, 'submitPage', 'POST', domain, task);
  }

  _createClass(SubmitPageRequest, [{
    key: "setOperation",
    value: function setOperation(operation) {
      this.operation = operation;
    }
  }, {
    key: "setPendingFileList",
    value: function setPendingFileList(documents) {
      this.documents = documents;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          record: this.record ? this.record.toJSON() : undefined,
          page: this.page ? this.page.toJSON() : undefined,
          recordOperation: this.operation,
          pendingFileList: this.documents,
          message: this.message ? this.message : undefined
        }
      };
    }
  }]);

  return SubmitPageRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = SubmitPageRequest;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var SubmitRecordRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(SubmitRecordRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(SubmitRecordRequest);

  function SubmitRecordRequest(domain, task) {
    _classCallCheck(this, SubmitRecordRequest);

    return _super.call(this, 'submitRecord', 'POST', domain, task);
  }

  _createClass(SubmitRecordRequest, [{
    key: "setOperation",
    value: function setOperation(operation) {
      this.operation = operation;
    }
  }, {
    key: "setPendingDocuments",
    value: function setPendingDocuments(documents) {
      this.documents = documents;
    }
  }, {
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      var content = _get(_getPrototypeOf(SubmitRecordRequest.prototype), "getSerializable", this).call(this);

      content.request1.recordOperation = this.operation;
      content.request1.pendingFileList = this.documents;
      return content;
    }
  }]);

  return SubmitRecordRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = SubmitRecordRequest;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var TaskListingRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(TaskListingRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(TaskListingRequest);

  function TaskListingRequest(domain, task, listTask) {
    var _this;

    _classCallCheck(this, TaskListingRequest);

    _this = _super.call(this, 'getTaskListing', 'POST', domain, listTask);

    _this.setSrcTask(task);

    return _this;
  }

  _createClass(TaskListingRequest, [{
    key: "setSrcTask",
    value: function setSrcTask(newTask) {
      this.srcTask = newTask;
    }
  }, {
    key: "setTemplate",
    value: function setTemplate(newTemplate) {
      this.template = newTemplate;
    }
  }, {
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          record: this.record ? this.record.toJSON() : undefined,
          task: this.srcTask,
          template: this.template
        }
      };
    }
  }]);

  return TaskListingRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = TaskListingRequest;

/***/ })
/******/ ]);
});
//# sourceMappingURL=sai-protocol-node.js.map